import http from "network/HTTPClient";

const PositionPeriod = {
  async all() {
    const response = await http.post("position/all");
    return response.data;
  },
  async insert(data) {
    const response = await http.post("position/insert", data);
    return response.data;
  },

  async update(key, values) {
    const response = await http.post("position/update", {
      id: key,
      values: values,
    });
    return response.data;
  },

  async delete(key) {
    const response = await http.post("position/delete", { id: key });
    return response.data;
  },
};

export default PositionPeriod;
